<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'comfort_calculator' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">

    <ng-container class="contentDiv">
      <div class="form-container">
        <div class="input-with-controls-group">
          <ion-label class="select-label">{{'temp_external' | translate}} ({{ tempUnitSymbol }})</ion-label>

          <div class="input-with-controls">
            <ion-input class="bordered-input" type="number" [(ngModel)]="eTe" name="eTe" (ionChange)="validateForm()"
              (ionBlur)="validateForm()">
            </ion-input>

            <!-- Control buttons container -->
            <div class="input-controls">
              <ion-button fill="clear" size="small" class="control-btn decrement-btn" (click)="decrementTe()">
                <ion-icon name="remove-outline"></ion-icon>
              </ion-button>

              <ion-button fill="clear" size="small" class="control-btn increment-btn" (click)="incrementTe()">
                <ion-icon name="add-outline"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>

        <div class="input-with-controls-group">
          <ion-label class="select-label">{{'temp_internal' | translate}} ({{ tempUnitSymbol }})</ion-label>

          <div class="input-with-controls">
            <ion-input class="bordered-input" type="number" [(ngModel)]="eTi" name="eTi" (ionChange)="validateForm()"
              (ionBlur)="validateForm()">
            </ion-input>

            <!-- Control buttons container -->
            <div class="input-controls">
              <ion-button fill="clear" size="small" class="control-btn decrement-btn" (click)="decrementTi()">
                <ion-icon name="remove-outline"></ion-icon>
              </ion-button>

              <ion-button fill="clear" size="small" class="control-btn increment-btn" (click)="incrementTi()">
                <ion-icon name="add-outline"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>

        <div class="input-with-controls-group">
          <ion-label class="select-label">{{'phi_internal' | translate}}</ion-label>
          <div class="input-with-controls">
            <ion-input class="bordered-input" type="number" [(ngModel)]="ePhi" name="ePhi" (ionChange)="validateForm()"
              (ionBlur)="validateForm()">
            </ion-input>

            <!-- Control buttons container -->
            <div class="input-controls">
              <ion-button fill="clear" size="small" class="control-btn decrement-btn" (click)="decrementPhi()">
                <ion-icon name="remove-outline"></ion-icon>
              </ion-button>

              <ion-button fill="clear" size="small" class="control-btn increment-btn" (click)="incrementPhi()">
                <ion-icon name="add-outline"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="descDiv input-with-controls-group">
      <ion-label class="select-label">{{'tsi_internal' | translate}} ({{ tempUnitSymbol }})</ion-label>
      <p>{{displayResSurfaceTemp}}</p>
      <ion-label class="select-label">{{'tdp_dew_point' | translate}} ({{ tempUnitSymbol }})</ion-label>
      <p>{{displayResDewPoint}}</p>
      <ion-label class="select-label">{{'tm_mould' | translate}} ({{ tempUnitSymbol }})</ion-label>
      <p>{{displayResMoldTemp}}</p>
    </div>

    <ion-chip color="primary" class="customChip primaryClass">
      <ion-label>
        <div class="chip-content">
          <div class="chip-title">{{'results' | translate}}</div>
          <div class="chip-description">
            <ul>
              <li>{{this.resCondensationMsg | translate}}</li>
              <li>{{this.resMouldMsg | translate}}</li>
            </ul>
          </div>
        </div>
      </ion-label>
    </ion-chip>

  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button class="next-btn" (click)="validate()" expand="block">
      {{'validate' | translate}}
    </ion-button>
  </div>
</ion-footer>